import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'languageRestriction',
})
export class LanguageRestrictionPipe implements PipeTransform {
  transform(value: any, args?: any): any {
    if (args === '') {
      return value;
    } else {
      return (
        value &&
        value.filter(
          (option) =>
            option.languageRestriction === args ||
            option.languageRestriction === undefined,
        )
      );
    }
  }
}
